import React from "react";
import axios from "axios";
import * as IoIcons from "react-icons/io";
function DequipoHospitalizacion(props) {
  const postRemove = (e) => {
    e.preventDefault(e);
    axios
      .delete(
        "https://suadesarrollo.azurewebsites.net/api/EliminaEquipoHospitalizacion/" +
          props.id,
      )
      .then((Response) => {
        console.log(Response);
        alert("Eliminado con exito");
      })
      .catch((error) => {
        console.log(error);
        alert(error);
      });
  };

  return (
    <div>
      <a>
        <button className="btn btn-danger" type="submit" onClick={postRemove}>
          <IoIcons.IoIosCloseCircleOutline />
        </button>
      </a>
    </div>
  );
}
export default DequipoHospitalizacion;
